module.exports = __webpack_public_path__ + "static/media/thumb-theresistance.1f1b1977.png";